import type { IconType } from 'react-icons';
import {
  LuLayoutDashboard, LuFileText, LuBuilding2, LuBoxes, LuIndianRupee, LuFolderOpen,
  LuCalendarClock, LuChartColumn, LuHistory, LuUsers, LuSettings, LuBuilding, LuBellRing, LuBriefcaseBusiness,
} from 'react-icons/lu';
import type { Permission } from '@/features/auth/permissions';

export interface NavItem {
  key: string;
  label: string;
  path: string;
  icon: IconType;
  permission: Permission;
  group: 'main' | 'records' | 'insight' | 'admin';
}

/** Single source of truth for navigation, breadcrumbs and route guards. */
export const NAV_ITEMS: NavItem[] = [
  { key: 'executive', label: 'Executive Overview', path: '/executive', icon: LuBriefcaseBusiness, permission: 'executive.view', group: 'main' },
  { key: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: LuLayoutDashboard, permission: 'tender.view', group: 'main' },
  { key: 'tenders', label: 'Tenders', path: '/tenders', icon: LuFileText, permission: 'tender.view', group: 'main' },
  { key: 'vendors', label: 'Vendors', path: '/vendors', icon: LuBuilding2, permission: 'tender.view', group: 'main' },
  { key: 'quantity', label: 'Quantity & Consumption', path: '/quantity', icon: LuBoxes, permission: 'tender.view', group: 'records' },
  { key: 'financials', label: 'Financials', path: '/financials', icon: LuIndianRupee, permission: 'tender.view', group: 'records' },
  { key: 'documents', label: 'Documents', path: '/documents', icon: LuFolderOpen, permission: 'tender.view', group: 'records' },
  { key: 'expiring', label: 'Expiring Contracts', path: '/expiring', icon: LuCalendarClock, permission: 'tender.view', group: 'records' },
  { key: 'reports', label: 'Reports', path: '/reports', icon: LuChartColumn, permission: 'report.export', group: 'insight' },
  { key: 'alerts', label: 'Alert History', path: '/alerts', icon: LuBellRing, permission: 'tender.view', group: 'insight' },
  { key: 'audit', label: 'Audit Logs', path: '/audit-logs', icon: LuHistory, permission: 'audit.view', group: 'insight' },
  { key: 'masterData', label: 'Master Data', path: '/master-data', icon: LuBuilding, permission: 'vendor.manage', group: 'admin' },
  { key: 'users', label: 'User Management', path: '/users', icon: LuUsers, permission: 'user.manage', group: 'admin' },
  { key: 'settings', label: 'Settings', path: '/settings', icon: LuSettings, permission: 'tender.view', group: 'admin' },
];

export const NAV_GROUP_LABELS: Record<NavItem['group'], string> = {
  main: 'Overview',
  records: 'Contract Records',
  insight: 'Insight & Compliance',
  admin: 'Administration',
};
